var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"18","viewBox":"0 0 21 18","fill":"none"}},[_c('rect',{attrs:{"width":"21","height":"6","fill":"white"}}),_c('rect',{attrs:{"y":"6","width":"21","height":"6","fill":"#4879D7"}}),_c('rect',{attrs:{"y":"12","width":"21","height":"6","fill":"#E92A2A"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }